export default __webpack_public_path__ + "images/1172300c44653eac0e7e530e2475a977.png";